import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { accountRoute } from '../../../routes';
import baseUrl from  '../../../utils/baseUrl';

import ContentBlock from '../block/content';

import CaseEditForm from './caseEditForm';

import GenericStep from './stepGeneric';

export default class AccountCaseCreateStep1 extends Component {
	static propTypes = {
		dispatch: PropTypes.func.isRequired,
		activeStep: PropTypes.number.isRequired,
		goToStep: PropTypes.func.isRequired,
		onSubmit: PropTypes.func.isRequired,
	};

	static defaultProps = {
		active: false,
		goToStep: function() {},
		onSubmit: function(promise) { promise.then(() => {}).catch(() => {}); },
	};

	constructor(props) {
		super();

		this.state = {};
	}

	componentWillMount() {}

	componentWillReceiveProps(nextProps) {}

	render() {
		let path = '/api/account/projects/create';

		return (
			<GenericStep
				active={this.props.activeStep === 1}
				stepNumber='01'
				stepTitle='Project'
				summary={this.renderSummary()}
			>
				<CaseEditForm
					ref='form'
					path={path}
					method='post'
					smallAside
					onSubmit={this.props.onSubmit}
					foot={this.renderFooter()}
					dispatch={this.props.dispatch}
					user={this.props.user}
				/>
			</GenericStep>
		);
	}

	renderSummary() {
		let active = (this.props.activeStep > 1);
		let className = 'account-block-content__content__summary';
		if (active) {
			className += ' account-block-content__content__summary--active';
		}

		let form = this.refs.form;
		let formRefs = (form && form.refs) ? form.refs : false;

		let type = (formRefs && formRefs.type && formRefs.type.value) ? formRefs.type.value : '';
		let name = (formRefs && formRefs.title && (typeof formRefs.title.value === 'function')) ? formRefs.title.value() : '';

		let credits = [];
		if (formRefs && formRefs.credits && formRefs.credits.value) {
			for (var i = 0; i < formRefs.credits.value.length; i++) {
				credits.push(formRefs.credits.value[i].name);
			}
		}
		credits = credits.join(', ');

		return (
			<div className={className}>

				{(active && this.props.activeStep !== 4) && (<button className='button account-block-content__content__summary__button' onClick={() => { this.props.goToStep() }}>Edit</button>)}

				<p>
					<strong>{type + (type && name ? ', ' : '') + name}</strong><br/>
					{credits}
				</p>

			</div>
		);
	}

	renderFooter() {
		return (
			<ContentBlock className='pixel-pattern pixel-pattern--01' smallAside={true}>
				<div className='span9 span100p-tablet span100p-mobile'>
					<div className='account-process__button-area'>
						<button type='submit' className='button--dark'>Continue</button>
						<span className='account-process__button-area__button-desc'>Next, you’ll complete the information that goes on the invoice and other formal details.</span>
					</div>
				</div>
			</ContentBlock>
		);
	}

	getRefs() {
		return this.refs;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/caseCreate/step1.js
 **/